import { render, staticRenderFns } from "./ModalUserV2.vue?vue&type=template&id=cd3f76fc"
import script from "./ModalUserV2.vue?vue&type=script&lang=js"
export * from "./ModalUserV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports